import React from 'react';

import { ContactsListProps, ContactsList } from './pages/ContactsList/ContactsList';
import { CallController, CallControllerProps } from './components/CallController/CallController';
import { MemoryGame, MemoryGameProps } from './pages/MemoryGame/MemoryGame';

export interface Route<Props> {
    props: Props;
    Component: React.FC<Props>;
}

interface RouteFactory<RouteProps> {
    (props: RouteProps): Route<RouteProps>;
}

export const contactsRoute: RouteFactory<ContactsListProps> = (props) => ({
    props,
    Component: ContactsList,
});

export const callRoute: RouteFactory<CallControllerProps> = (props) => ({
    props,
    Component: CallController,
});

export const gameRoute: RouteFactory<MemoryGameProps> = (props) => ({
    props,
    Component: MemoryGame,
});

export type AllowedRoute =
    | Route<CallControllerProps>
    | Route<ContactsListProps>
    | Route<MemoryGameProps>;
